import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";
import * as io from "socket.io-client";
import "./AdminAnniv2025.css";
import constants from "../../../../config/constants";
import useTheme from "@mui/material/styles/useTheme";
import Box from "@mui/material/Box";
import {selectSessionUser} from "../../../../store/authentication/selectors";
import {Button} from "react-bootstrap";
import {AquilaUltima} from "./games/AquilaUltima";
import {JuliusClash} from "./games/JuliusClash";
import {VoxSenatus} from "./games/VoxSenatus";


export const AdminAnniv2025Page = () => {

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const theme = useTheme();

    const [state, setState] = useState(undefined);
    const [player, setPlayer] = useState(undefined);
    const [players, setPlayers] = useState([]);
    const [socketAnniv, setSocketAnniv] = useState(undefined);
    const [juliusClashPoints, setJuliusClashPoints] = useState({});
    const stateRef = useRef(state);

    const user = useSelector(selectSessionUser);

    useEffect(() => {
        const tempSocketAnniv = io.connect(constants.api.socketPath, {transports: ['websocket']});
        tempSocketAnniv.on('anniv2025-state', function (data) {
            console.log("jai recu un state");
            console.log(data);
            const parsedState = JSON.parse(data);
            setState(parsedState);
        });
        tempSocketAnniv.on('anniv2025-corePlayers', function (data) {
            setPlayers(JSON.parse(data).corePlayers);
        })
        tempSocketAnniv.on('anniv2025-juliusclash-points', function (data) {
            setJuliusClashPoints(JSON.parse(data).points);
        })
        tempSocketAnniv.connect();
        tempSocketAnniv.emit("anniv2025-join", JSON.stringify({playerId: "gameServer"}));
        setSocketAnniv(tempSocketAnniv);
        setPlayer(user.username);
        return () => {
            tempSocketAnniv.close();
            console.log("closing socket");
        }
    }, []);

    if (!state || !player) {
        return <div>Waiting for desktop admin</div>
    }


    function newState(newState) {
        setState(newState);
        socketAnniv.emit("anniv2025-state", JSON.stringify(newState));
    }

    function startAquilaUltima() {
        const updatedState = {
            ...state,
            aquilaUltimaState: {
                currentScreen: "HOME",
                stepScreen: 0,
                players: [],
                moraleBoost: 0
            }
        };
        newState(updatedState);
    }

    function startJuliusClash() {
        const updatedState = {
            ...state,
            juliusClash: true
        };
        newState(updatedState);
    }

    function startAquaRoma() {
        const updatedState = {
            ...state,
            aquaRoma: true
        };
        newState(updatedState);
    }

    function startVoxSenatus() {
        const updatedState = {
            ...state,
            voxSenatusState: {
                leftTeam1: undefined,
                rightTeam1: undefined,
                subject1: undefined,
                leftTeam2: undefined,
                rightTeam2: undefined,
                subject2: undefined,
                currentDebate: 0,
                timer1: undefined,
                timer2: undefined,
                timerStart: undefined
            }
        };
        newState(updatedState);
    }

    function rocketLeagus() {
        const updatedState = {
            ...state,
            rocketLeagus: true
        };
        newState(updatedState);
    }

    function startWaiting() {
        const updatedState = {
            ...state,
            waiting: true,
            video_intro: false
        };
        newState(updatedState);
    }

    function startVideoIntro() {
        const updatedState = {
            ...state,
            video_intro: true,
            waiting: false
        };
        newState(updatedState);
    }

    function resetState() {
        newState({
            points: state.points ? state.points : {},
        });
    }

    function resetPoints() {
        newState({
            ...state,
            points: {}
        });
    }

    function displayRanking() {
        const updatedState = {
            ...state,
            displayRanking: true
        };
        newState(updatedState);
    }

    return (
        <div>
            <br/>
            <br/>
            <br/>
            {
                state && !state.aquilaUltimaState && !state.juliusClash && !state.voxSenatusState && !state.aquaRoma && !state.displayRanking && !state.rocketLeagus && !state.waiting && !state.video_intro ?
                    <div>
                        Démarrer un jeu ?
                        <br/>
                        <br/>
                        <Button onClick={startAquilaUltima}>
                            Start Aquila Ultima
                        </Button>
                        <br/>
                        <Button onClick={startJuliusClash}>
                            Start Julius Clash
                        </Button>
                        <br/>
                        <Button onClick={startAquaRoma}>
                            Start Aqua Roma
                        </Button>
                        <br/>
                        <Button onClick={startVoxSenatus}>
                            Start Vox Senatus
                        </Button>
                        <br/>
                        <Button onClick={rocketLeagus}>
                            Démarrer Rocket Leagus
                        </Button>
                        <br/>
                        <Button onClick={displayRanking}>
                            Afficher le classement
                        </Button>
                        <br/>
                        <br/>
                    </div>
                    : undefined
            }
            {
                state && !state.waiting ?
                    <Button onClick={startWaiting}>
                        Passer en état "waiting"
                    </Button> :
                    undefined
            }
            <br/>
            {state && !state.video_intro ?

                <Button onClick={startVideoIntro}>
                    Passer en état "video_intro"
                </Button> :
                undefined
            }
            <br/>
            {
                state && state.aquilaUltimaState ?
                    <AquilaUltima newState={newState} state={state} socketAnniv={socketAnniv}>

                    </AquilaUltima>

                    : undefined
            }
            {
                state && state.juliusClash ?
                    <JuliusClash socketAnniv={socketAnniv} state={state} newState={newState}
                                 juliusClashPoints={juliusClashPoints}>

                    </JuliusClash>
                    : undefined
            }
            {
                state && state.voxSenatusState ?
                    <VoxSenatus socketAnniv={socketAnniv} state={state} newState={newState}>
                    </VoxSenatus>
                    : undefined
            }
            {/* Vues simples pour les nouveaux états */}
            {
                state && state.waiting ?
                    <div>
                        Vous êtes dans l'état: waiting
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    : undefined
            }
            {
                state && state.video_intro ?
                    <div>
                        Vous êtes dans l'état: video_intro
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    : undefined
            }
            <div>
                Points :
                {
                    players.map((p) => {
                        return <div key={p.name}>
                            {p.name} : {state.points[p.name] ? state.points[p.name] : 0}
                        </div>
                    })
                }
                <br/>
                <br/>
                <br/>
                Rajouter des points aux équipes :
                {
                    ["BABYLON", "EGYPT", "GREECE", "CELTS"].map((team) => {
                        return <div key={team} style={{marginTop: "10px"}}>
                            {team} :
                            {
                                [-1, 1, 5, 10, 15, 20].map((pts) => {
                                    return <Button key={pts} style={{marginLeft: "10px"}} onClick={() => {
                                        const updatedPoints = {...state.points};
                                        for (const p of players.filter((pl) => pl.civilisation === team)) {
                                            if (!updatedPoints[p.name]) {
                                                updatedPoints[p.name] = 0;
                                            }
                                            updatedPoints[p.name] += pts;
                                        }
                                        newState({
                                            ...state,
                                            points: updatedPoints
                                        });
                                    }}>
                                        {pts > 0 ? `+${pts}` : pts}
                                    </Button>
                                })
                            }
                        </div>
                    })
                }

                <br/>
                <br/>
                <br/>
                <br/>
                <div>
                    Reset points :
                    <Button onClick={resetPoints}>
                        RESET POINTS
                    </Button>
                </div>
            </div>
            <div style={{height: "10vh", width: "50vw"}}></div>
            <Button onClick={resetState}>
                RESET
            </Button>
            <div style={{height: "50vh", width: "50vw"}}></div>
        </div>
    )
};
